import React from "react"
import { Button } from "components/button"
import { NextIcon, PreviousIcon } from "./assets/SliderArrows"
interface SliderControllerProps {
  activeIndex: number
  numberOfReviews: number
  onSlideNext: () => void
  onSlidePrev: () => void
}

export const SliderController = ({
  activeIndex,
  numberOfReviews,
  onSlideNext,
  onSlidePrev,
}: SliderControllerProps) => {
  const isFirstSlide = activeIndex - 1 === 0,
    isLastSlide = activeIndex === numberOfReviews

  return (
    <div className="u-flex-center-align fr-testimonial__slider-controller">
      <Button
        disabled={isFirstSlide}
        extraClassNames="fr-testimonial__slider-btn"
        onClick={() => onSlidePrev()}
        variant="primary-text-link"
      >
        <PreviousIcon />
      </Button>
      <span className="fr-testimonial__slider-controller-page">
        {activeIndex} of {numberOfReviews}
      </span>
      <Button
        disabled={isLastSlide}
        extraClassNames="fr-testimonial__slider-btn"
        onClick={() => onSlideNext()}
        variant="primary-text-link"
      >
        <NextIcon />
      </Button>
    </div>
  )
}
